<template>
  <div class="page" v-if="!toLogin">
    <Tabs
      :tabs="tabs"
      :month="month"
    />
    <Contents :isApplied="isApplied" :loaded="loaded" :isAuthed="isAuthed" @to-login="shoudLogin" :month="month"/>
  </div>
  <div class="thanks-page" v-else>
    <div class="thanks">
      <div class="title-wrapper">
        <h2 class="thanks-title">抽選会はリトル・ママ会員のみ</h2>
      </div>
      <div>
        <p class="advise">登録は３分でカンタン終了♪</p>
      </div>
      <div>
        <p class="advise">リトル・ママ会員になって抽選会に参加しませんか？</p><br>
      </div>
      <div class="btn-wrapper">
        <button
          type="button"
          class="grayout"
          @click="toRegister()"
        >登録して抽選会に参加</button>
      </div>
      <div class="to-login">
        <a :href="loginPage">会員なのでログインする</a>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import Tabs from '@/components/organisms/Tabs.vue'
import Contents from '@/components/organisms/Contents.vue'
import firebase from 'firebase'
import 'firebase/firestore'

export default {
  name: 'home',
  components: {
    Tabs,
    Contents
  },
  data: () => ({
    tabs: [],
    isApplied: false,
    loaded: false,
    isAuthed: false,
    toLogin: false
  }),
  computed: {
    ...mapState([
      'dateTab',
      'accessToken'
    ]),
    ...mapGetters([
      'accessToken',
      'getUserData'
    ]),
    month () {
      return this.$route.params.month
    },
    // ログイン判定する時の環境
    loginPage () {
      const host = location.host
      if (host.match(/local/)) { // ローカル
        return 'http://local.l-ma.co.jp:3000/login?from=onlinefesta'
      } else if (host.match(/stg/)) { // ステージング
        return 'https://stg.l-ma.co.jp/login?from=onlinefesta'
      } else { // 本番
        return 'https://l-ma.co.jp/login?from=onlinefesta'
      }
    }
  },
  async mounted () {
    this.setDate()
    const now = this.$moment(new Date())
    const TimestampAt0729 = new Date('2020-07-29 00:00:00').getTime()
    this.setTab()
    await this.setAccessToken()
    await this.fetchUserData()
    const userData = await this.getUserData
    const email = userData.email
    if (email) {
      this.isAuthed = true
      firebase.firestore().collection('lottery').where('email', '==', email).get()
        .then((querySnapshot) => {
          querySnapshot.docs.forEach((doc) => {
            const timeStamp = doc.data().createdAt.seconds * 1000
            if (now < TimestampAt0729 && timeStamp < TimestampAt0729) {
              this.isApplied = true
            }
            if (now >= TimestampAt0729 && timeStamp >= TimestampAt0729) {
              this.isApplied = true
            }
          })
          this.loaded = true
        })
    } else {
      this.isAuthed = false
      this.loaded = true
    }
    document.title = 'リトル・ママオンラインフェスタ〜学べる・遊べる・繋がれる〜'
  },
  methods: {
    ...mapMutations([
      'setDateTab',
      'setAccessToken'
    ]),
    ...mapActions([
      'fetchUserData'
    ]),
    setTab () {
      let date
      if (this.month === '202006') {
        const isSecondDay = this.$moment().isSame('2020-06-25', 'day')
        date = isSecondDay ? '2020-06-25' : '2020-06-24'
      } else if (this.month === '202007') {
        const isSecondDay = this.$moment().isSame('2020-07-29', 'day')
        date = isSecondDay ? '2020-07-29' : '2020-07-28'
      } else if (this.month === '202008') {
        const isSecondDay = this.$moment().isSame('2020-08-28', 'day')
        date = isSecondDay ? '2020-08-28' : '2020-08-27'
      } else {
        const isSecondDay = this.$moment().isSame('2020-10-03', 'day')
        date = isSecondDay ? '2020-10-03' : '2020-10-02'
      }
      this.setDateTab(date)
    },
    shoudLogin () {
      this.toLogin = true
    },
    toRegister () {
      window.location.href = 'https://l-ma.co.jp/register?from=onlinefesta'
    },
    setDate () {
      if (this.month === '202006') {
        this.tabs.push({ name: '2020-06-24' }, { name: '2020-06-25' })
      } else if (this.month === '202007') {
        this.tabs.push({ name: '2020-07-28' }, { name: '2020-07-29' })
      } else if (this.month === '202008') {
        this.tabs.push({ name: '2020-08-27' }, { name: '2020-08-28' })
      } else if (this.month === '202009') {
        this.tabs.push({ name: '2020-09-15' })
      } else {
        this.tabs.push({ name: '2020-10-02' }, { name: '2020-10-03' })
      }
    }
  }
}
</script>

<style lang="sass" scoped>
.tabs-wrapper
  width: 100%
  background-color: #fff
  position: fixed
  top: 0
  left: 0
  z-index: 10
.thanks
  background-color: #fffff
  text-align: center
  font-size: 30px
img
  margin: 20px 30px
.advise-box
  padding: 0.5em 1em
  margin: 0 2em 2em
  font-weight: bold
  border: solid 3px #00ac3d
  p
    color: #00ac3d
    text-align: left
    padding: 1em
    line-height: 1.6
.select-wrapper
  margin-left: 30px
  background-color: #3ebd92
  border-radius: 8px
  overflow: hidden
  position: relative
  &::before
    content: ''
    width: 12px
    height: 12px
    border: 3px solid #fff
    border-width: 0 3px 3px 0
    transform: rotate(45deg)
    position: absolute
    top: 12px
    right: 10px
    margin: auto
    pointer-events: none
select
  width: 100%
  height: 40px
  color: #fff
  background-color: transparent
  background-image: none
  border: none
  line-height: 40px
  padding: 0 40px 0 10px
  outline: none
  appearance: none
  font-size: 1.2rem
  &::-ms-expand
    display: none
  option
    color: #000
.consent
  margin-left: 30px
.address
  margin-left: 30px
  .content
    margin-bottom: 10px
  .sub-title
    margin: 10px 10px  0 0
    width: 100px
  span
    display: inline-block
  .address-wrapper
    display: flex
    margin-bottom: 10px
    input
      width: 250px
      height: 30px
    .select-pref-wrapper
      height: 40px
      background-color: #3ebd92
      border-radius: 8px
      overflow: hidden
      position: relative
      &::before
        content: ''
        width: 12px
        height: 12px
        border: 3px solid #fff
        border-width: 0 3px 3px 0
        transform: rotate(45deg)
        position: absolute
        top: 12px
        right: 10px
        margin: auto
        pointer-events: none
.thanks-page
  margin: 20px 20px
  height: 90vh
  border: medium solid gray
  .thanks
    padding: 20px
    line-height: initial
    background-color: #ffffff
    .title-wrapper
      text-align: center
      .thanks-title
        font-size: 24px
  .advise
    margin-top: 20px
    font-size: 14px
    text-align: center
.btn-wrapper
  width: 100%
  max-width: 320px
  margin: 0 auto
  button
    display: flex
    justify-content: center
    align-items: center
    width: 100%
    height: 56px
    color: #fff
    background-color: $green
    border: none
    border-radius: 8px
    padding: 0
    margin: 0 auto
    font-size: 1.6rem
    cursor: pointer
.to-login
  text-decoration: underline
  font-size: 16px
  margin-top: 20px
</style>
